import {
    SquareCheckBig,
    List,
    Calendar,
    Users
} from "lucide-react";

import { useLocation } from "wouter";
import { useEffect } from "react";

const allTabs = [
    { id: "mytasks", label: "My Tasks", icon: <SquareCheckBig size={18} /> },
    { id: "list", label: "Projects", icon: <List size={18} /> },
    // { id: "calendar", label: "Calendar", icon: <Calendar size={18} /> },
    // { id: "team", label: "Team", icon: <Users size={18} /> },
];

export default function ProjectTab({
    active,
    setActive,
    user,
    activeProjectId
}) {

    const isAdminorManagement =
        user?.department === "Admin" || user?.department === "Management";

    const [currentPath] = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tab = params.get("tab");

        if (tab) {
            setActive(tab);
        } else {
            setActive("mytasks");
        }
    }, []);

    const tabs = isAdminorManagement
        ? allTabs
        : allTabs.filter(
            (tab) => tab.id === "mytasks" || tab.id === "list"
        );

    const handleTabClick = (tabId) => {
        if ((tabId === 'calendar' || tabId === 'team') && !activeProjectId) {
            alert("Please select a project first");
            return;
        }
        setActive(tabId);
    };

    return (
        <div className="flex gap-6  border-gray-200 mb-[20px]">
            <div className="tabs-header flex border-b border-gray-300 mb-4 fixed w-full bg-white z-20">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => handleTabClick(tab.id)}
                        className={`
      px-4 py-2 rounded-t-lg font-medium
      transition-all duration-200
      flex items-center gap-2
      text-[12px] lg:text-sm
      ${active === tab.id
                                ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600"
                                : "text-gray-500 hover:text-blue-600 hover:bg-gray-100"
                            }
      ${["calendar", "team"].includes(tab.id) ? "hidden md:flex" : ""}
    `}
                    >
                        <span>{tab.icon}</span>
                        <span>{tab.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}
